module.exports = __webpack_public_path__ + "img/89.1c42b8c7.png";